var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"footer",attrs:{"fluid":""}},[_c('b-row',{staticClass:"copyright",staticStyle:{"margin-left":"0","margin-right":"0"}},[_c('b-col',{attrs:{"sm":"12","xl":"8","offset-xl":"2"}},[_c('div',{staticClass:"btm-row"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }